import React from 'react';
import { useTranslation } from 'react-i18next';
import { Info, ExternalLink, ExternalLinkIcon } from 'lucide-react';

const About = () => {
    const { t, i18n } = useTranslation();
    const primaryGreen = "#006C35";
    const isAr = i18n.language === 'ar';

    return (
        <div className="min-h-screen bg-gray-50 pb-20 overflow-hidden">
            {/* Header / Hero Section */}
            <div className="bg-white border-b border-gray-100 pt-32 pb-16">
                <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8`}>
                    <h1 className={`text-4xl font-extrabold text-gray-900 ${isAr ? 'border-r-8 pr-6' : 'border-l-8 pl-6'} inline-block`} style={{ borderColor: primaryGreen }}>
                        {t('about.title')}
                    </h1>
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8 mt-12 gap-12">
                <div className="bg-white rounded-3xl p-4 md:p-12 shadow-sm border border-gray-100 flex flex-col h-full">
                    <div className={`flex items-center gap-4 mb-8`}>
                        <div className="p-3 rounded-2xl bg-green-50 text-[#006C35]">
                            <Info size={32} />
                        </div>
                        <h2 className={`md:text-2xl text-base font-bold text-gray-800`}>
                            {t('about.subtitle')}
                        </h2>
                    </div>

                    <div className={`space-y-6 text-gray-700 leading-relaxed text-lg`}>
                        <p>{t('about.p1')}</p>
                        <p>{t('about.p2')}</p>
                        <p>{t('about.p3')}</p>
                        <p>{t('about.p4')}</p>
                    </div>

                    {/* <div className={`mt-auto pt-10 flex`}>
                        <a
                            href="https://s1.ksaprv.cloud.ariba.com/Sourcing/Main/ad/selfRegistration?realm=744968928"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`sm:text-base text-[10px] inline-flex items-center justify-center w-full md:w-auto px-8 py-4 bg-[#006C35] text-white font-bold rounded-2xl hover:bg-[#005430] transition-all shadow-lg hover:shadow-xl active:scale-95 gap-3`}
                        >
                            {t('about.registerLink')}
                            <ExternalLinkIcon size={18} className="transform group-hover:rotate-12 transition-transform" />
                        </a>
                    </div> */}
                </div>
            </div>
        </div>
    );
};

export default About;
